import { Component, inject } from '@angular/core';

import { ResponsiveTableService } from './core/service/responsive-table/responsive-table.service';
@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
})
export class AppComponent {
  private responsiveTables = inject(ResponsiveTableService);

  constructor() {
    this.responsiveTables.start();
  }}
